<style lang="scss">
  .box-view-def{
    width: 1000px;
    margin: 0 auto;
    font-size: 14px;
    .title{
      text-align: center;
      margin-bottom: 30px;
      margin-top: 30px;
    }
    .author{
      color: #2342ff;
    }
    h1{
      font-size: 20px;
    }
    h2{
      font-size: 16px
    }
  }
</style>
<template>
  <div class="box-view-def">
    <div class="title">
      <h1>{{info.infoTitle}}</h1>
      <h2 v-show="info.infoSrc">来自：{{info.infoSrc}}</h2>
      <h2>{{info.infoDt|format}}  <span class="author">{{info.infoAuthor}}</span></h2>
    </div>
    <div v-html="info.infoDesc"></div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        info: {}
      }
    },
    props: {},
    methods: {
      getCon () {
        axios.post("/medapp/api/con/info/get",{
          info_id: this.$route.params.infoId
        })
          .then(({data})=>{
            if(data.code*1 === 0){
              this.info = data.info
              document.title = data.info.infoTitle
            }
          })
      }
    },
    computed: {},
    filters:{
      format(t){
        if(t){
          return new Date(t).Format('yyyy-MM-dd')
        }else{
          return ''
        }
      }
    },
    created(){
      this.getCon()
    },
    mounted() {
    }
  }
</script>




// WEBPACK FOOTER //
// view.vue?167e519a